export default __webpack_public_path__ + "static/media/html5-boilerplate.5b0a9681.svg";